<template>
  <div class="m_container">
    <Header :title="title" />
    <section class="m_section">
      <div v-if="!showResult" class="m_form">
        <div class="banner">
          <img width="100%" src="../../assets/images/banner-cx.jpg" alt="查询">
        </div>
        <div class="form">
          <el-form
            ref="dataForm"
            :rules="rules"
            :model="temp"
            label-position="right"
            label-width="85"
            class="my_form"
          >
            <el-form-item prop="name">
              <el-input v-model="temp.name" placeholder="请输入姓名" />
            </el-form-item>

            <el-form-item prop="id_card">
              <el-input v-model="temp.id_card" placeholder="请输入证件号" />
            </el-form-item>

            <el-form-item>
              <el-button v-loading="saveLoading" type="primary" class="submitbtn" @click="saveSignUp">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-else class="main info">
        <div class="num">{{ result.subject_record }}</div>
        <div class="item">
          <p class="item_label">姓名</p>
          <p>：</p>
          <p class="item_val">{{ result.member_name ? result.member_name :'' }}</p>
        </div>
        <div class="item">
          <p class="item_label">证件号</p>
          <p>：</p>
          <p class="item_val">{{ result.id_card ? result.id_card :'' }}</p>
        </div>
        <div class="item">
          <p class="item_label">科目</p>
          <p>：</p>
          <p class="item_val">{{ result.subject_name ? result.subject_name :'' }}</p>
        </div>
        <div class="item">
          <p class="item_label">成绩</p>
          <p>：</p>
          <p class="item_val">{{ result.subject_record ? `${result.subject_record}分` :'' }}</p>
        </div>
      </div>
    </section>
    <TabBar :current-tab="currentTab" />
  </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import { getSid, setSid } from '@/utils/cookies'
import { mapGetters } from 'vuex'
import { searchRecord } from '@/api/Signup'

export default {
  name: 'SearchScoreResult',
  components: { Header, TabBar },
  data() {
    return {
      sid: this.$route.query.sid ? this.$route.query.sid : getSid(),
      currentTab: 'searchScore',
      title: '考级查询',
      saveLoading: false,
      showResult: false,
      result: {},
      rules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        id_card: [
          { required: true, message: '证件号不能为空', trigger: 'blur' }
        ]
      },
      temp: {
        sid: this.$route.query.sid ? this.$route.query.sid : getSid(),
        name: '',
        id_card: ''
      }
    }
  },
  computed: {
    ...mapGetters(['examInfo'])
  },
  created() {
    this.sid ? setSid(this.sid) : ''
  },
  methods: {
    saveSignUp() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.saveLoading = true
          searchRecord(this.temp).then(res => {
            this.saveLoading = false
            if (res.code === 200) {
              this.result = res.data
              this.showResult = true
            }
          }).catch(() => {
            this.saveLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.noscroll{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.m_container{
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f5f5f5;

  .m_section {
    flex:1;

    .form{
      margin: 20px;
    }

    .submitbtn{
      width: 100%;
      margin: 20px auto 0;
      background: var(--bck);
    }

    .info{
      margin: 15px;
      padding: 40px;
      background: #fff;
      line-height: 32px;
      text-align: left;
      font-size: 14px;

      .num{
        height:120px;
        line-height: 82px;
        color:#fff;
        text-align:center;
        font-size:40px;
        font-weight:bold;
        background:url('../../assets/images/score.png') no-repeat center;
        background-size:contain;
        margin: 0 0 20px;
      }

      .item{
        display: flex;
        justify-content: space-between;
        align-items: center;

        .item_label{
          flex: 0 0 60px;
          color: #999;
          display: inline-block;
          text-align:justify;
          text-align-last: justify;
          line-height: 0px;
          transform: translateY(2px);

          &:after {
            display: inline-block;
            width: 100%;
            content: '';
            height: 0;
          }
        }

        .item_val{
          flex:1;
          color: #000;
        }
      }
    }
  }
}
.m_container .el-form-item{
  padding-left:0;
}
</style>
